<template>
  <van-search
    v-model="value"
    :placeholder="convertLanage(placeholder)"
    show-action
    maxlength="17"
    class="component-search-input van-hairline--bottom"
    @search="handleSearch"
    @cancel="handleClear"
    @blur="validateVin(value)"
  >
    <template #action>
      <div @click="handleSearch">{{ convertLanage('搜索') }}</div>
    </template>
  </van-search>
</template>

<script>

import { convertLanage } from '@/utils/lanage'
export default {
  name: 'SearchInput',
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索关键词'
    }
  },
  data() {
    return {
      upperCaseValue: ''
    }
  },
  computed: {
    // 小写自动转大写
    value: {
      get() {
        return this.upperCaseValue
      },
      set(val) {
        this.upperCaseValue = val.toUpperCase()
      }
    }
  },
  methods: {
    /**
     * 简繁体语言转换
     */
    convertLanage(strs) {
      return convertLanage(strs)
    },
    /**
     * 设值
     */
    setValue(value) {
      this.value = value
    },

    /**
     * 校验vin码
     * @param vin 当前vin码
     */
    validateVin(vin) {
      // 如果没有输入vin码，或者vin码不合法，则抛出异常消息并返回false
      if (!vin) {
        this.$emit('validation', convertLanage('请输入VIN码'))
        return false
      } else if (vin.length !== 17 || !/^([0-9]|[a-z]|[A-Z]){17}$/.test(vin)) {
        this.$emit('validation', convertLanage('请输入正确的VIN码,17位字母与数字组合'))
        return false
      } else {
        return true
      }
    },

    /**
     * 搜索方法
     */
    handleSearch() {
      if (this.validateVin(this.value)) {
        this.$emit('search', this.value)
      }
    },

    /**
     * 清空操作
     */
    handleClear() {
      this.value = ''
    }
  }
}
</script>

<style lang="scss">
.component-search-input {
  padding: 25px 0;

  .van-search__content {
    background-color: transparent;
    padding-left: 0;

    .van-cell.van-field {
      padding: 0;
      height: 45px;
    }
  }

  .van-search__action {
    color: #0761F3;
    font-size: 30px;
    text-align: center;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchInput.vue